import React from 'react';
import CourseContent from "./CourseContent";


const CourseContentRenderer = () => {

    return (
        <CourseContent/>
    );

};


export default CourseContentRenderer;